import { render, staticRenderFns } from "./SfBottomModal.vue?vue&type=template&id=68b8b48f"
import script from "./SfBottomModal.vue?vue&type=script&lang=js"
export * from "./SfBottomModal.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfBottomModal.vue?vue&type=style&index=0&id=68b8b48f&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "49fcd912"
  
)

export default component.exports